import PropTypes from 'prop-types'

import { Span } from 'components'

type Props = ISpan & {
  bedroom: number | string
}

export const Bedroom: React.FC<Props> = ({ bedroom, ...style }) => {
  const bedroomText = bedroom === 0 ? 'Studio' : `${bedroom} Bedrooms`
  return <Span {...style}>{bedroomText}</Span>
}

Bedroom.propTypes = {
  bedroom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
